<template>
	<div class="download-container">
		<div class="header-bar" @click="$router.back()">
			<van-icon name="arrow-left" class="back-icon" />
		</div>
		<img class="logo" src="@/assets/icon/icon_download_logo.png" alt="五行商户LOGO">
		<img class="desc" src="@/assets/icon/icon_download_desc.png" alt="" />
		<button class="download-btn" @click="goDownload">点击下载</button>
		<img class="sponsor-img" src="@/assets/icon/icon_download_sponsor.png" alt="" />
		<img class="bottom-img" src="@/assets/icon/icon_download_bottom.png" alt="" />
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch'
	export default {
		name: "CDBDownload",
		data() {
			url: null;
		},
		created() {
			this.systemInfo();
			this.$parent.footer('user', false);
		},
		methods: {
			systemInfo() {
				Fetch('/user/system_info').then((r) => {
					this.url = r.data.app;
				});
			},
			goDownload() {
				window.location.href = this.url;
			},
		}
	};
</script>

<style scoped>
	.download-container {
		display: flex;
		text-align: center;
		align-items: center;
		flex-direction: column;
		/* border-radius: 18px; */
		/* padding: 62px 16px 24px 16px; */
		color: #b22222;
		font-family: "微软雅黑", sans-serif;
		height: 100vh;
		width: 10rem;
		background: url(~@/assets/sign_bg.png) 100% no-repeat;
		background-size: 100% 100%;
	}

	.header-bar {
		width: 100%;
		padding: 4.26667vw;
		display: flex;
		align-items: center;
	}

	.header-bar .back-icon {
		font-size: 6.4vw;
		color: #fff;
		text-shadow: 0 1px .53333vw rgba(0, 0, 0, .3);
	}

	.logo {
		width: 5rem;
	}

	.desc {
		width: 90%;
		position: absolute;
		bottom: 50%;
	}

	.download-btn {
		background: #d82b2b;
		color: #fdb44b;
		font-size: 24px;
		border: none;
		border-radius: 10px;
		border: 1px solid;
		padding: 15px 0;
		width: 50%;
		cursor: pointer;
		font-weight: bold;
		box-shadow: 0 2px 8px rgba(216, 43, 43, 0.2);
		position: absolute;
		bottom: 35%;
	}

	.open-app {
		font-size: 14px;
		color: #7a2323;
	}

	.open-app a {
		color: #d82b2b;
		text-decoration: underline;
		margin-left: 4px;
	}

	.sponsor-img {
		width: 90%;
		background-color: #fff;
		border-radius: 15px;
		opacity: 0.7;
		position: absolute;
		bottom: 20%;
	}

	.bottom-img {
		width: 110%;
		position: absolute;
		bottom: 0px;
	}
</style>